export const API_BATI_CHIFFRAGE_CONFIG_ROUTE = '/api/bati-chiffrage/config';
